module.exports = __webpack_public_path__ + "static/media/media-6.bbd40add.jpg";